import React from 'react';
import { Trans } from '@lingui/react';

export default {
    availableStudents: <Trans>Available Students</Trans>,
    assigned: <Trans>Students assigned to</Trans>,
    manage: <Trans>Select a class to manage</Trans>,
    assignedFor: <Trans>Assigned students for</Trans>,
    youHave: <Trans>You have</Trans>,
    moved: <Trans>moved</Trans>,
    copied: <Trans>copied</Trans>,
    Student: <Trans>Student</Trans>,
    Students: <Trans>Students</Trans>,
    have: <Trans>have</Trans>,
    has: <Trans>has</Trans>,
    beenUnassigned: <Trans>been unassigned</Trans>
};



// WEBPACK FOOTER //
// ./containers/students/students-text.js